<template>
  <div class="bdy">
    <div class="headbt">
      <span class="zjt" @click="fh"><img src="../../assets/img/zjt.png" ></span>测评详情&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </div>


    <div class="cpjg">
        <!-- <div class="cpjg_title">
            测量表测评
        </div> -->
        <div class="cpjg_detail">
          <div class="cp-report-title">{{title}}</div>
          <div class="cp-report-box">
            <div class="cp-report-row">
              <div class="cp-report-td1">最接近M</div>
              <div class="cp-report-td1">数量</div>
              <div class="cp-report-td1">相减</div>
              <div class="cp-report-td1">最不接近L</div>
              <div class="cp-report-td1">数量</div>
              <div class="cp-report-td1">等于</div>
              <div class="cp-report-td2">结果允许有负分</div>
            </div>
            <div class="cp-report-row" v-for="(item,index) in cpfjinfo" :key="index">
              <div class="cp-report-td1">{{item.symbolM}}</div>
              <div class="cp-report-td1">{{item.dataM}}</div>
              <div class="cp-report-td1">{{item.subtracts}}</div>
              <div class="cp-report-td1">{{item.symbolL}}</div>
              <div class="cp-report-td1">{{item.dataL}}</div>
              <div class="cp-report-td1">{{item.equalTo}}</div>
              <div class="cp-report-td2">{{item.results}}</div>
            </div>
          </div>


        </div>
    </div>







   <!-- <div class="fixed-right" @click="tz('/user/kefu')">
     <img src="../../assets/img/zxzx.png" >
     <br>
     在线咨询
   </div> -->
   <div class="footer">
     <div class="item_list_menu col-sm-3 col-3 col-md-3"  @click="tz('/base/index')">
   	  <div class="dibumenu">
         	 <img src="../../assets/img/home.png" >
   	</div>
   	  <div class="xmtitle ">
   	  	首页
   	  </div>
     </div>
   	<div class="item_list_menu col-sm-3 col-3 col-md-3" @click="tz('/user/cprw')">
   		<div class="dibumenu">
         	<!-- <img src="../../static/wd.png" > -->
            <img src="../../assets/img/cp.png" >
   		</div>
   		<div class="xmtitle " >
   			测评任务
   		</div>
   	</div>
   	<div class="item_list_menu col-sm-3 col-3 col-md-3" @click="tz('/user/wdcp')">
   		<div class="dibumenu">
   		 	 <img src="../../assets/img/wdcp_xz.png" >
   		</div>
   		<div class="xmtitle xmtitle_active">
   			我的测评
   		</div>
   	</div>
   	<div class="item_list_menu col-sm-3 col-3 col-md-3" @click="tz('/user/index')">
   		<div class="dibumenu">
   			 <img src="../../assets/img/wd.png" >
   		</div>
   		<div class="xmtitle ">
   			我的
   		</div>
   	</div>
   </div>
   <div class="jbk">

   </div>

  </div>
</template>

<script>
import {ckpcjg1} from '../../api/baseset'
  export default {
      data() {
        return {
              show_num:1,
              cpfjinfo:{},
              lbid:'',
              rwid:'',
              tableData:[],
              tabdata_count:0,
              title:'量表测试'
        }
      },
      mounted() {
        this.lbid = this.$route.params.id;
        this.rwid = this.$route.params.rwid;
        this.title = this.$route.params.title;
        this.getdata(this.lbid, this.rwid);
     // this.getsjtjs();
      },
      methods: {

        getdata(id,rwid){

          this.loading = true
          let parm={gaugeId:id,taskId:rwid}
            ckpcjg1(parm)
             .then(res => {

               this.loading = false
               if (res.code != 200) {
                 this.$message({
                   type: 'info',
                   message: res.msg
                 })
               } else {
                 // console.log(res)
                  //this.cpfjinfo.cpsm = res.
                 // this.cpfjinfo.pj = res.data.overallEvaluation //评价
                 // this.cpfjinfo.jg = res.data.evaluatingResult //结果
                  //this.cpfjinfo.jy = res.data.expertAdvice //建议
                  //this.cpfjinfo.sm = res.data.explanation
                  //this.cpfjinfo.df = res.data.totalScore
                  this.cpfjinfo = res.data;

                //   console.log(this.cpfjinfo)
                 // console.log(this.tabdata_count)
               }
             })
             .catch(err => {
               this.loading = false
               this.$message.error('数据加载失败，请稍后再试！')
             })

        },

        // 搜索事件
        search() {
          this.formInline.page = 1
          this.formInline.limit = 10
          this.getdata(this.formInline)
        },
        // 重置搜索
        formReset() {
          this.formInline.key = '';
        },
        shouli() {

        },
        chuli() {
          this.dialogVisible = true;
        },
        tz(url){

          this.$router.push(url);
        },
        fh(){
        // window.history.go(-1);
         this.$router.push("/user/wdcp");
        }
      }
    }
  </script>

<style scoped>
  	body{
  			background-color: white !important;
  		}
    .bdy{
      background-color: white !important;
    }
    .cpjg_title{
      width: 100%;
      height: 35px;
      line-height: 35px;
      text-align: center;
      margin-top: 15px;
    }
    .cpjg_detail{
          margin: 0 auto;
          padding-bottom: 50px;
          width: 95%;
          min-height: 200px !important;
         /* border: 10px solid #e9fafa; */
          border-radius: 50px;
          position: relative;
          margin-top: 15px;
    }
    .cpt{
      width: 101px;
      height: 31px;
      margin: 0 auto;

      margin-top: -20px;
    }
    .cpt img{
      width: 100px;
      height: 32px;
    }
    .fenshu{

      width: 64px;
      height: 64px;
      margin: 0 auto;
       margin-top: 30px;
      border-radius: 50%;
      background-color: #00DDA3;
      line-height: 64px;
      text-align: center;
      color: white;

    }
    .cp_title{
      width: 90%;
      height: 35px;
      font-weight: bold;
      color: #00DDA3;
      font-size: 14px;
      margin: 0 auto;
      margin-top: 40px;
    }
    .cp_content{
      width: 90%;
      margin: 0 auto;
      margin-top: 1px;
      height: auto;
      font-size: 14px;
      color: #666666;
      padding-top: 1px;
      padding-bottom: 10px;
      line-height: 24px;

    }
    .cpcp{
      width: 90%;
      height: auto;
      margin: 0 auto;
      padding-top: 5px;
      padding-bottom: 5px;
      font-size: 14px;
       line-height: 24px;
        color: #666666;
      margin-top: 15px;
      display: block;
        /*  word-break: break-all; */
          word-wrap: break-word;
    }
    .cpcp_title{
      padding-top: 5px;
      padding-bottom: 5px;
      padding:5px 15px 5px 15px;
      background-color: #00DDA3;
      text-align: center;
      font-size: 14px;
      font-weight:bold;
      color: white;
    }
    .list-group-item{
    	border-radius: 0 0 0 0 ;
    	border: none !important;
    	padding:  0 0 0 0 !important;

    	height: 3rem;
    	line-height:3rem;
    	font-size: 14px;
    	color: #666666;
    	border-bottom: solid  1px #E6EAEC !important;
    }
    .list-group-item:first-child{
    	border-top-left-radius: 0;
    	border-top-right-radius: 0;

    }
    .item_list_menu{
    	/* border: solid 1px red; */
    	text-align: center;
    }
    .cp_xz{
      width: 95%;
      height: auto;
      margin:  0 auto;

      padding-top: 10px;
      padding-bottom: 10px;
    }
    .bordered-table {
      border-collapse: collapse; /* 可选，用于让边框合并为一个单一的边框 */
    }
    .bordered-table td, .bordered-table th {
      border: 1px solid #ccc;
    }

  .cp-report-title{font-size: 18px;font-weight: bold;text-align: center;}
  .cp-report-box{border-top: solid 1px #ddd;border-left: solid 1px #ddd;margin-top: 20px;font-size: 14px;}
  .cp-report-row{border-bottom: solid 1px #ddd;display: flex;}
  .cp-report-td1{width: 13%;border-right: solid 1px #ddd;line-height: 26px;height: auto;text-align: center;}
  .cp-report-td2{width: 22%;border-right: solid 1px #ddd;line-height: 26px;height: auto;text-align: center; }
</style>



// WEBPACK FOOTER //
// src/views/user/wdcpdetail1.vue